import React from "react";
import IndustrialEntry from "../components/IndustrialEntry";

export default function IndustrialPurchase() {
  return <IndustrialEntry type="purchase" />;
}
